import { Routes } from "@angular/router";
import { SurveysComponent } from "./pages/surveys/surveys.component";
import { SurveysListComponent } from "./pages/surveys/surveys-list/surveys-list.component";
import { authGuard } from "./guards/auth.guard";

export const routes: Routes = [
	{
		path: "",
		redirectTo: "surveys",
		pathMatch: "full",
	},
	{
		path: "login",
		loadComponent: () => import("./pages/login/login.component").then((m) => m.LoginComponent),
	},
	{
		path: "auth/email-link-signin",
		loadComponent: () =>
			import("./pages/auth/email-link-signin/email-link-signin.component").then(
				(m) => m.EmailLinkSigninComponent,
			),
	},
	{
		path: "auth/wrong-device",
		loadComponent: () =>
			import("./pages/auth/wrong-device/wrong-device.component").then(
				(m) => m.WrongDeviceComponent,
			),
	},
	{
		path: "surveys",
		component: SurveysComponent,
		canActivate: [authGuard],
		children: [
			{
				path: "",
				component: SurveysListComponent,
			},
			{
				path: ":organizationSurveyId/:userId",
				loadComponent: () =>
					import("./pages/surveys/survey-detail/survey-detail.component").then(
						(m) => m.SurveyDetailComponent,
					),
			},
		],
	},
	{
		path: "profile",
		loadComponent: () =>
			import("./pages/profile/profile.component").then((m) => m.ProfileComponent),
		canActivate: [authGuard],
	},
	{
		path: "**",
		redirectTo: "surveys",
	},
];
